module.exports = "/images/pillOuterRing2.png?0454bf8e07a7e8180ab58e88e8536901";